export default __webpack_public_path__ + "static/framat-44b1e677cb4fba610b4539406042333d.svg";